function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.42 23H0V7.96h4.42V23zM2.65 5.3a2.65 2.65 0 11-.01-5.32 2.65 2.65 0 01.01 5.33zM23 23h-4.8v-7.56c0-1.8-.05-4.11-2.52-4.11-2.5 0-2.89 1.95-2.89 3.98V23H7.96V7.47h4.63v2.12h.07a5.07 5.07 0 014.56-2.51c4.88 0 5.78 3.21 5.78 7.39V23z",
  fill: "#043828"
});

function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgMjMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuNDIgMjNIMFY3Ljk2aDQuNDJWMjN6TTIuNjUgNS4zYTIuNjUgMi42NSAwIDExLS4wMS01LjMyIDIuNjUgMi42NSAwIDAxLjAxIDUuMzN6TTIzIDIzaC00Ljh2LTcuNTZjMC0xLjgtLjA1LTQuMTEtMi41Mi00LjExLTIuNSAwLTIuODkgMS45NS0yLjg5IDMuOThWMjNINy45NlY3LjQ3aDQuNjN2Mi4xMmguMDdhNS4wNyA1LjA3IDAgMDE0LjU2LTIuNTFjNC44OCAwIDUuNzggMy4yMSA1Ljc4IDcuMzlWMjN6IiBmaWxsPSIjMDQzODI4IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
export { SvgLinkedinLogo as ReactComponent };